import { StringTMap } from '@@types/common';

import { PANEL_TYPE } from '~/constants';
import { isArchivedChannel, isNonPrivateChannel } from '~/services/channelService';
import Actions from '~/stores/Actions';
import { stores } from '~/stores/Stores';
import { uiState } from '~/stores/UiState';
import { userStore } from '~/stores/UserStore';
import { isWindows } from '~/utils/runEnvironmentUtil';
import shortcutService from '~/utils/shortcutService';

class ShortcutActions {
  private metaKey = isWindows() ? 'ctrl' : 'command';
  private readonly globalKeyMap: StringTMap<(e: KeyboardEvent) => void> = {};

  constructor(private actions: Actions) {
    this.globalKeyMap = {
      [`${this.metaKey}+i`]: this.handleInvite,
      ...(uiState.isPopupView ? {} : { [`${this.metaKey}+f`]: this.handleSearch }),
    };
  }

  bindGlobalKeyMap = () => {
    shortcutService.globalBind({ key: Object.keys(this.globalKeyMap), callback: this.handleGlobalShortcut });
  };

  handleGlobalShortcut = (e: KeyboardEvent, key: string) => {
    this.globalKeyMap[key]?.(e);
  };

  private handleInvite = () => {
    const { contentsChannel } = stores;
    if (
      !contentsChannel ||
      isNonPrivateChannel(contentsChannel) ||
      isArchivedChannel(contentsChannel) ||
      userStore.isGuest
    )
      return;
    this.actions.modalActions.openChannelInvite({ channel: contentsChannel, members: contentsChannel.members });
  };

  private handleSearch = (e: KeyboardEvent) => {
    if (uiState.panelType !== PANEL_TYPE.LOG) {
      e.preventDefault();
    }
    uiState.setPanelType(PANEL_TYPE.LOG);
    document.querySelector<HTMLInputElement>('.js-collection-panel-search-input')?.focus();
  };
}

export default ShortcutActions;
